// ContentGrid component to display content items in a grid layout
import { Grid } from '@mui/material';
import React from 'react';
import { ContentCard } from './ContentCard';

export function ContentGrid({ data, viewAllPath }) {
  return (
    <Grid
      container
      spacing={2}
      sx={{ marginTop: 2, alignItems: 'center' }}
    >
      {data.map((item) => (
        <ContentCard
          key={item.id}
          title={item.title}
          imageUrl={item.imageUrl}
          linkPath={`${viewAllPath}/${item.id}`}
        />
      ))}
    </Grid>
  );
}
